import React from 'react';
import CohortCardItem from '../containers/CohortCardItem';

const CohortCardItems = ({
  category,
  items,
  onCheckBoxClick,
  showStatus,
  showTools,
  single,
}) => (
  items.map((item, index) => (
    <CohortCardItem
      category={category}
      cohort={item}
      key={`cohorts_card_item_${item.id}`}
      onCheckBoxClick={onCheckBoxClick}
      showStatus={showStatus}
      showTools={showTools}
      single={single}
      upward={index > 4}
    />
  ))
);

export default CohortCardItems;
